module.exports = __webpack_public_path__ + "static/img/22390145.3c416993.png";